export default "__VITE_ASSET__BLMQwatT__"